import { css } from "@emotion/react";
import { media } from "styles/breakpoints";
import { theme } from "styles/theme";

export const TransferPageStyle = {
  wrapper: css`
    display: flex;
    flex-direction: column;
    max-width: 1200px;
    padding: 20px;
    background: ${theme.colors.black100};
    border-radius: 12px;
    min-height: 100%;
    border: 1px solid ${theme.borders.primary};

    ${media.md} {
      border-radius: 0;
      border: none;
      background: transparent;
      gap: 10px;
    }
  `,
  container: css`
    padding: 0 16px;
  `,
  header: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;
    color: ${theme.palette.text.primary};

    svg {
      width: 24px;
      height: 24px;
      filter: drop-shadow(0 0 4px ${theme.palette.accent.glow});
      color: ${theme.borders.primary};
    }

    svg,
    svg * {
      stroke-width: 2;
    }

    span {
      font-size: ${theme.typography.sectionTitle.fontSize};
      font-weight: ${theme.typography.sectionTitle.fontWeight};
      line-height: ${theme.typography.sectionTitle.lineHeight};
      letter-spacing: ${theme.typography.sectionTitle.letterSpacing};
      color: ${theme.palette.text.primary};
    }

    ${media.md} {
      color: ${theme.palette.text.primary};
    }
  `,
  wrapInner: css`
    padding: 24px;
    border-radius: 10px;
    background: ${theme.colors.black100};
    border: 1px solid ${theme.borders.primary};
    box-shadow: 0 4px 12px 0 rgba(107, 123, 168, 0.25);
    margin-top: 16px;

    &:first-of-type {
      margin-top: 0;
    }

    ${media.md} {
      box-shadow: 0 4px 12px 0 rgba(107, 123, 168, 0.25);
      padding: 24px;
    }

    .title-heading {
      color: ${theme.colors.lightText};
      font-size: 18px;
      font-weight: 600;
      line-height: 18px;
      margin-bottom: 30px;
      ${media.md} {
        padding-bottom: 0;
        text-align: center;
        font-size: 22px;
      }
    }

    .note {
      margin-top: 15px;
      font-size: 12px;
      color: red;
      font-style: italic;
      text-align: left;
    }
  `,
  form: css`
    position: relative;

    .box-transfer {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 20px;

      ${media.md} {
        flex-direction: column;
      }
    }

    .box-transfer-point {
      align-items: flex-start;

      .transfer-point-player-select {
        &.ant-select-disabled {
          .ant-select-selector {
            background: #4f4f4f !important;
            border-color: #4f4f4f !important;
            box-shadow: none !important;
          }

          .ant-select-selection-placeholder,
          .ant-select-selection-item,
          .ant-select-arrow {
            color: #bababa !important;
            opacity: 1 !important;
          }
        }
      }
    }

    .box-item {
      flex: 1;
      width: 100%;

      .label {
        margin-bottom: 5px;
        color: ${theme.colors.lightText};
      }

      .balance {
        margin-top: 5px;
        display: flex;
        align-items: center;
        gap: 5px;
        color: ${theme.colors.lightText};

        ${media.md} {
          justify-content: flex-end;
        }

        span {
          font-size: 13px;
          font-weight: 500;

          &.value {
            font-weight: 700;
            color: ${theme.colors.darkGreen};
          }
        }
      }
    }

    .btn-switch {
      cursor: pointer;
      margin-top: 10px;
      color: ${theme.colors.darkGreen};
      user-select: none;

      ${media.md} {
        transform: rotateZ(90deg);
      }
    }
  `,
  btnSubmit: css`
    display: flex;
    align-items: center;
    justify-content: center;

    button {
      max-width: 300px;
      width: 100%;
      height: 44px;
      border-radius: 8px;
      background: ${theme.colors.gradient[1]};
      margin-top: 40px;
      font-weight: 600;
      color: ${theme.colors.text.buttonActive};
      border: none;
      box-shadow: 0 4px 12px 0 rgba(107, 123, 168, 0.25);

      &:disabled {
        background: #4f4f4f;
        color: #bababa;

        &:hover {
          color: #bababa !important;
        }
      }

      ${media.md} {
        max-width: unset;
      }

      :hover {
        transform: translateY(-1px);
        color: ${theme.colors.text.buttonActive} !important;
      }
    }
  `,
};
